import axios from "axios";
import React, { useEffect, useState } from "react";
import { Socket, io } from "socket.io-client";
import { useApp } from "../context/app-context";
import yellowRedCardImg from "../assets/yellowRedCard.png";
import ball from "../assets/scorer.png";
import assistImg from "../assets/assist.png";
// 2025
import penSaved from "../assets/goalieSave.png";
import DummyImg from "../assets/user.png";
import PlayerModal from "./PlayerModal";
import { ArrowDownIcon } from "@heroicons/react/20/solid";
import swal from "sweetalert";

const SOCKET_URL = `${process.env.REACT_APP_SERVER_URL}`;
// const socket = io.connect(SOCKET_URL);

var socket = io(SOCKET_URL, { transports: ["websocket"] });

function MatchScoreCard() {
  const { eachMatchData, setEachMatchData, liveMatch } = useApp();
  //  2025 changes
  const [ArrangedMatchStats, setArrangedMatchStats] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [team_logo, setTeam_logo] = useState(DummyImg);
  const [timeline, setTimeline] = useState();

  const closeModal = () => setIsModalOpen(false);

  const matchId = liveMatch._id;
  useEffect(() => {
    socket.on("connect", () => {
      console.log("Connected to the server");
    });
    socket.on("stats-updated", (updatedMatch) => {
      console.log("Match updated:", updatedMatch);
      ArrangeStats(updatedMatch?.stats);
      // Handle the updated match data (e.g., update the state or UI)
    });
  }, []);
  useEffect(() => {
    getEachMatchData(
      `${process.env.REACT_APP_SERVER_URL}/api/match/${matchId}`
    );
  }, []);

  //2025:
  function ArrangeStats(Stats) {
    console.log(Stats);

    const data1 = ArrangeTeam1Stats(Stats);

    const data2 = ArrangeTeam2Stats(Stats);

    const combined = {
      team1: data1,
      team2: data2,
    };
    console.log("SortedMatchStats", combined);
    setArrangedMatchStats(combined);

    const matchTimeline = ArrangeTimelineFromBothTeams(combined);
    console.log("📊 Match Timeline:", matchTimeline);
    setTimeline(matchTimeline);
  }

  function ArrangeTeam2Stats(Stats) {
    const formattedOwnGoals = Stats?.team1?.ownGoals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.player,
      type: "ownGoals",
      _id: goal._id,
    }));

    // Convert regular goals with a type field too (optional)
    const formattedGoals = Stats?.team2?.goals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.scorer,
      assist: goal.assist,
      type: "goal",
      _id: goal._id,
    }));

    const allGoals = [...formattedGoals, ...formattedOwnGoals].sort(
      (a, b) => a.minute - b.minute
    );

    const team = Stats?.team2;
    const sortedYellowdCards = team?.yellowCards.sort(
      (a, b) => a.minute - b.minute
    );
    const sortedRedCards = team?.redCards.sort((a, b) => a.minute - b.minute);

    const sortedPenaltySaved = team?.penaltySaved.sort(
      (a, b) => a.minute - b.minute
    );

    const data = {
      goals: allGoals,
      yellowCards: sortedYellowdCards,
      redCards: sortedRedCards,
      penaltySaved: sortedPenaltySaved,
      totalGoals: team?.totalGoals,
    };
    console.log("team2 : ", data);
    return data;
  }

  function ArrangeTeam1Stats(Stats) {
    // For team1 goals
    const formattedOwnGoals = Stats?.team2?.ownGoals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.player,
      type: "ownGoals",
      _id: goal._id,
    }));

    const formattedGoals = Stats?.team1?.goals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.scorer,
      assist: goal.assist,
      type: "goal",
      _id: goal._id,
    }));

    const allGoals = [...formattedGoals, ...formattedOwnGoals].sort(
      (a, b) => a.minute - b.minute
    );
    const team = Stats?.team1;
    const sortedYellowdCards = team?.yellowCards.sort(
      (a, b) => a.minute - b.minute
    );
    const sortedRedCards = team?.redCards.sort((a, b) => a.minute - b.minute);
    const sortedPenaltySaved = team?.penaltySaved.sort(
      (a, b) => a.minute - b.minute
    );

    const data = {
      goals: allGoals,
      yellowCards: sortedYellowdCards,
      redCards: sortedRedCards,
      penaltySaved: sortedPenaltySaved,
      totalGoals: team?.totalGoals,
    };
    console.log("team1 : ", data);

    return data;
  }

  function ArrangeTimelineFromBothTeams(arrangedStats) {
    const {
      team1: {
        goals: team1Goals = [],
        yellowCards: team1Yellow = [],
        redCards: team1Red = [],
        penaltySaved: team1Penalty = [],
      } = {},
      team2: {
        goals: team2Goals = [],
        yellowCards: team2Yellow = [],
        redCards: team2Red = [],
        penaltySaved: team2Penalty = [],
      } = {},
    } = arrangedStats;

    const combinedTimeline = [
      ...team1Goals.map((item) => ({
        ...item,
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Goals.map((item) => ({
        ...item,
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
      ...team1Yellow.map((item) => ({
        ...item,
        type: "yellowCards",
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Yellow.map((item) => ({
        ...item,
        type: "yellowCards",
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
      ...team1Red.map((item) => ({
        ...item,
        type: "redCards",
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Red.map((item) => ({
        ...item,
        type: "redCards",
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
      ...team1Penalty.map((item) => ({
        ...item,
        type: "penaltySaved",
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Penalty.map((item) => ({
        ...item,
        type: "penaltySaved",
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
    ];

    const sortedTimeline = combinedTimeline.sort((a, b) => a.minute - b.minute);
    return sortedTimeline;
  }

  //
  const openPhotoModalFunc = (photo) => {
    setIsModalOpen(true);
    setTeam_logo(photo);
  };

  async function getEachMatchData(url) {
    try {
      const response = await axios.get(url);
      console.log("GET Match request successful");
      console.log(response.data.match);
      setEachMatchData(response.data.match);
      ArrangeStats(response.data.match.stats);
      console.log(eachMatchData);
    } catch (error) {
      console.error("Error making GET match request:", error);
    }
  }

  // 2025 delete

  const deleteMatchEvent = async ({ matchId, eventType, statId, team }) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/api/match/edit/${matchId}/event/${eventType}/${statId}/delete`,
        { team }
      );
      console.log("Event deleted successfully:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error deleting event:", err);
      throw err;
    }
  };

  const deleteFunc = (event) => {
    const matchId = eachMatchData?._id;
    let eventType = event?.type;
    const statId = event?._id;
    const team = event?.teamNumber;

    //
    if (eventType == "goal") {
      eventType = "goals";
    }
    console.log("matchId", matchId);
    console.log("Type: ", eventType);
    console.log("event id : ", statId);
    console.log("team: : ", team);

    swal({
      title: "Are you sure?",
      text: "Once clicked on okay, event will be deleted !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        console.log("deleted");
        deleteMatchEvent({ matchId, eventType, statId, team });
      } else {
        swal("Event not deleted!");
      }
    });
  };

  const renderCard = (event) => (
    <div key={event.id}>
      <div className="w-full flex justify-center mb-2">
        <ArrowDownIcon className="w-6 h-6 " />
      </div>
      <span className="flex justify-center text-green-700 font-semibold text-lg ">
        {event?.minute}'
      </span>

      <div
        key={event.id}
        className="bg-white border shadow p-2 rounded-lg flex justify-between flex flex-col  max-w-xl "
      >
        {/* <div className="flex items-end text-green-600">{event.minute}'</div> */}
        <div className="bg-indigo-700 flex rounded-lg text-white mb-2 py-1 font-bold uppercase items-center justify-between">
          {/* {event?.team} */}

          {event?.type === "goal" && <img src={ball} className="mx-2 w-5" />}
          {(event?.type === "yellowCards" || event?.type === "redCards") && (
            <img src={yellowRedCardImg} className="mx-2 w-5" />
          )}
          {event?.type === "ownGoals" && (
            <>
              <span className="font-bold pl-1">(OG) </span>
            </>
          )}
          {event?.type === "penaltySaved" && (
            <img src={penSaved} className="mx-2 w-5" />
          )}
          {/* when event name ends with s removes s else display event name */}
          {event?.type?.endsWith("s") ? event.type.slice(0, -1) : event?.type}

          <span className="flex items-end text-green-600 mr-2 rounded-lg bg-white p-0.5">
            {/* {event?.minute}' */}
            <img
              src={event?.teamLogo}
              alt={event?.teamNumber}
              className="w-6 h-6 rounded-md  "
            />
          </span>
        </div>
        {/* <div className="flex text-lg font-semibold justify-center uppercase items-center">
        {event.type} (
        <div className="flex items-end text-green-600">{event.minute}'</div>)
      </div> */}
        <div className="text-sm text-gray-700">
          {event?.type === "goal" && (
            <div className="flex gap-2 justify-between">
              <p>
                <strong>Scorer:</strong> {event?.scorer?.name}
              </p>
              {event?.assist?.name && (
                <p>
                  <strong>Assist:</strong> {event?.assist?.name}
                </p>
              )}
            </div>
          )}
          {event?.type === "ownGoals" && (
            <p>
              <strong>Own Goal By:</strong> {event?.scorer?.name}
            </p>
          )}
          {event?.type === "penaltySaved" && (
            <p>
              <strong>Saved By:</strong> {event?.player?.name}
            </p>
          )}
          {(event?.type === "yellowCards" || event?.type === "redCards") && (
            <p>
              <strong>Player:</strong> {event?.player?.name}
            </p>
          )}
        </div>

        <div
          className="bg-red-700 rounded-lg text-white mt-2 py-1 font-bold"
          onClick={() => deleteFunc(event)}
        >
          Delete
        </div>
      </div>
    </div>
  );
  return (
    <>
      <div className="mx-auto my-5 max-w-xl rounded overflow-hidden shadow-md text-xs">
        <PlayerModal
          isOpen={isModalOpen}
          onClose={closeModal}
          team_logo={team_logo}
        />
        <div className="flex bg-gray-200 px-2 py-2 justify-between">
          <div className="w-5/12 text-gray-700 text-left ">
            Week {eachMatchData?.week}
          </div>
          {/* <div className="w-5/12 flex justify-end items-center">
                      <p className="w-8 px-2 text-center">1</p>
                      <p className="w-8 px-2 text-center">2</p>
                      <p className="w-8 px-2 text-center">3</p>
                      <p className="w-8 px-2 text-center">4</p>
                    </div> */}
          {eachMatchData?.live ? (
            <div className="w-1/6 text-red-700 text-right">Live</div>
          ) : (
            <div className="w-1/6 text-gray-700 text-right">Not Live</div>
          )}
        </div>
        <div className="flex items-center bg-white">
          <div className="flex px-2 py-2 items-end bg-white flex-col w-full cursor-pointer">
            {/* Raptors Section */}
            <div className="w-full flex items-center flex-col">
              <img
                className="w-12 sm:w-10 mr-2 self-center justify-center"
                alt="away-logo"
                src={eachMatchData?.team1logo}
              />

              <div className="flex ">
                <p className=" text-base font-bold text-center">
                  {eachMatchData?.team1}
                </p>
              </div>
            </div>
          </div>
          <p className=" bg-white text-2xl flex px-2 py-2  text-nowrap">
            {ArrangedMatchStats?.team1?.totalGoals} -{" "}
            {ArrangedMatchStats?.team2?.totalGoals}
          </p>

          <div className="flex px-2 py-2 items-end bg-white flex-col w-full cursor-pointer">
            {/* Raptors Section */}
            <div className="w-full flex items-center flex-col">
              <img
                className="w-12 sm:w-10 mr-2 self-center justify-center"
                alt="away-logo"
                src={eachMatchData?.team2logo}
              />

              <div className="flex ">
                <p className=" text-base font-bold text-center">
                  {eachMatchData?.team2}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2025 */}
        <div className="block border-t-2 border-gray-300  bg-white">
          <div className="flex justify-center my-2 items-center">
            <p className="text-center  text-gray-500 font-semibold text-md  uppercase">
              Goals
            </p>
            <img src={ball} className="mx-2 w-5" />
          </div>

          {/* column wise sepration */}

          <div className="flex">
            <div className="w-1/2   flex">
              <div className="flex flex-col">
                {ArrangedMatchStats?.team1?.goals?.map((goalScored) => (
                  <>
                    <div className=" px-2 py-2 flex flex-col  mb-1">
                      <p className="justify-center text-center  mb-2 text-green-600">
                        {goalScored.minute}'
                      </p>
                      <div className="flex items-center">
                        <img
                          className="w-10 mr-2 self-center rounded-md  "
                          src={goalScored.scorer.photo}
                          alt="Player 1"
                          onClick={() =>
                            openPhotoModalFunc(goalScored.scorer.photo)
                          }
                        />
                        <div className="flex flex-col">
                          <p className="font-semibold">
                            {goalScored.scorer.name}
                          </p>
                          {goalScored.type === "ownGoals" ? (
                            <p className="text-gray-600 ">(Own Goal)</p>
                          ) : (
                            <p className="text-gray-600">Goal Scored</p>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* <div className=" px-2 py-2 flex flex-col  mb-1">
                                    <p className="justify-center text-center  mb-2 text-green-600"></p>
                                    <div className="flex items-center">
                                      <div className="flex flex-col">
                                        <p className="font-semibold"></p>
                                        <p className="text-gray-600"></p>
                                      </div>
                                      <div className="h-10 mr-2 self-center" />
                                    </div>
                                  </div> */}
                  </>
                ))}
              </div>
            </div>

            <div className=" w-1/2 flex  justify-end px-1">
              <div className="flex flex-col">
                {ArrangedMatchStats?.team2?.goals?.map((goalScored) => (
                  <>
                    {/* <div className=" px-2 py-2 flex flex-col  mb-1">
                                    <p className="justify-center text-center  mb-2 text-green-600"></p>
                                    <div className="flex items-center">
                                      <div className="flex flex-col">
                                        <p className="font-semibold"></p>
                                        <p className="text-gray-600"></p>
                                      </div>
                                      <div className="h-10 mr-2 self-center" />
                                    </div>
                                  </div> */}
                    <div className=" px-2 py-2 flex flex-col items-end mb-1">
                      <p className="justify-center text-center  mb-2 text-green-600">
                        {goalScored.minute}'
                      </p>
                      <div className="flex items-center">
                        <div className="flex flex-col items-end">
                          <p className="font-semibold">
                            {goalScored.scorer.name}
                          </p>
                          {goalScored.type === "ownGoals" ? (
                            <p className="text-gray-600 ">(Own Goal)</p>
                          ) : (
                            <p className="text-gray-600">Goal Scored</p>
                          )}
                        </div>
                        <img
                          className="w-10 ml-2 self-center rounded-md "
                          src={goalScored.scorer.photo}
                          alt="Player 1"
                          onClick={() =>
                            openPhotoModalFunc(goalScored.scorer.photo)
                          }
                        />
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>

          <div className="flex justify-center p-2 border-t border-gray-300 items-center">
            <p className="text-center  text-gray-500 font-semibold text-md  uppercase">
              Assists
            </p>
            <img src={assistImg} className="mx-2 w-5" />
          </div>
          {/* column wise sepration */}

          <div className="flex">
            <div className="w-1/2   flex">
              <div className="flex flex-col">
                {ArrangedMatchStats?.team1?.goals?.map((goalScored) => (
                  <>
                    {goalScored.assist !== undefined &&
                      goalScored.assist !== null && (
                        <div className=" px-2 py-2 flex flex-col  mb-1">
                          <p className="justify-center text-center  mb-2 text-green-600">
                            {goalScored.minute}'
                          </p>
                          <div className="flex items-center">
                            <img
                              className="w-10 mr-2 self-center rounded-md"
                              src={goalScored.assist.photo}
                              alt="Player 1"
                              onClick={() =>
                                openPhotoModalFunc(goalScored.assist.photo)
                              }
                            />
                            <div className="flex flex-col">
                              <p className="font-semibold">
                                {goalScored.assist.name}
                              </p>
                              <p className="text-gray-600">Assisted</p>
                            </div>
                          </div>
                        </div>
                      )}
                    {/* <div className=" px-2 py-2 flex flex-col  mb-1">
                                    <p className="justify-center text-center  mb-2 text-green-600"></p>
                                    <div className="flex items-center">
                                      <div className="flex flex-col">
                                        <p className="font-semibold"></p>
                                        <p className="text-gray-600"></p>
                                      </div>
                                      <div className="h-10 mr-2 self-center" />
                                    </div>
                                  </div> */}
                  </>
                ))}
              </div>
            </div>

            <div className=" w-1/2 flex  justify-end px-1">
              <div className="flex flex-col">
                {ArrangedMatchStats?.team2?.goals?.map((goalScored) => (
                  <>
                    {/* <div className=" px-2 py-2 flex flex-col  mb-1">
                                    <p className="justify-center text-center  mb-2 text-green-600"></p>
                                    <div className="flex items-center">
                                      <div className="flex flex-col">
                                        <p className="font-semibold"></p>
                                        <p className="text-gray-600"></p>
                                      </div>
                                      <div className="h-10 mr-2 self-center" />
                                    </div>
                                  </div> */}
                    {goalScored.assist !== undefined &&
                      goalScored.assist !== null && (
                        <div className=" px-2 py-2 flex flex-col  mb-1">
                          <p className="justify-center text-center  mb-2 text-green-600">
                            {goalScored.minute}'
                          </p>
                          <div className="flex items-center">
                            <div className="flex flex-col items-end ">
                              <p className="font-semibold">
                                {goalScored.assist.name}
                              </p>
                              <p className="text-gray-600">Assisted</p>
                            </div>
                            <img
                              className="w-10 ml-2 self-center rounded-md"
                              src={goalScored.assist.photo}
                              alt="Player 1"
                              onClick={() =>
                                openPhotoModalFunc(goalScored.assist.photo)
                              }
                            />
                          </div>
                        </div>
                      )}
                  </>
                ))}
              </div>
            </div>
          </div>

          {/* Penalty Saved */}
          {ArrangedMatchStats?.team1.penaltySaved.length !== 0 ||
          ArrangedMatchStats?.team2.penaltySaved.length !== 0 ? (
            <>
              <div className="flex justify-center p-2 border-t border-gray-300 items-center">
                <div className="flex justify-center my-2 items-center">
                  <p className="text-center  text-gray-500 font-semibold text-md  uppercase">
                    Penalty Saved
                  </p>
                  <img src={penSaved} className="mx-2 w-5" />
                </div>
              </div>
              <div className="flex">
                <div className="w-1/2   flex">
                  <div className="flex flex-col">
                    {ArrangedMatchStats?.team1?.penaltySaved?.map(
                      (penaltySaved) => (
                        <>
                          {penaltySaved !== undefined &&
                            penaltySaved !== null && (
                              <div className=" px-2 py-2 flex flex-col  mb-1">
                                <p className="justify-center text-center  mb-2 text-green-600">
                                  {penaltySaved?.minute}'
                                </p>
                                <div className="flex items-center">
                                  <img
                                    className="w-10 mr-2 self-center rounded-md"
                                    src={penaltySaved?.player?.photo}
                                    alt="Player 1"
                                    onClick={() =>
                                      openPhotoModalFunc(
                                        penaltySaved?.player?.photo
                                      )
                                    }
                                  />
                                  <div className="flex flex-col">
                                    <p className="font-semibold">
                                      {penaltySaved?.player.name}
                                    </p>
                                    <p className="text-gray-600">
                                      Penalty Saved
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                        </>
                      )
                    )}
                  </div>
                </div>

                <div className=" w-1/2 flex  justify-end px-1">
                  <div className="flex flex-col">
                    {ArrangedMatchStats?.team2?.penaltySaved?.map(
                      (penaltySaved) => (
                        <>
                          {penaltySaved !== undefined &&
                            penaltySaved !== null && (
                              <div className=" px-2 py-2 flex flex-col  mb-1">
                                <p className="justify-center text-center  mb-2 text-green-600">
                                  {penaltySaved.minute}'
                                </p>
                                <div className="flex items-center">
                                  <div className="flex flex-col items-end ">
                                    <p className="font-semibold">
                                      {penaltySaved.player.name}
                                    </p>
                                    <p className="text-gray-600">
                                      Penalty Saved{" "}
                                    </p>
                                  </div>
                                  <img
                                    className="w-10 ml-2 self-center rounded-md"
                                    src={penaltySaved.player.photo}
                                    alt="Player 1"
                                    onClick={() =>
                                      openPhotoModalFunc(
                                        penaltySaved.player.photo
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            )}
                        </>
                      )
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="flex justify-center p-2 border-t border-gray-300 items-center">
            <p className="text-center  text-gray-500 font-semibold text-md  uppercase">
              Cards
            </p>
            <img src={yellowRedCardImg} className="mx-2 w-5" />
          </div>
          <div className="flex">
            <div className="w-1/2   flex">
              <div className="flex flex-col">
                {ArrangedMatchStats?.team1?.yellowCards?.map((yellowCard) => (
                  <>
                    <div className=" px-2 py-2 flex flex-col  mb-1">
                      <p className="justify-center text-center  mb-2 text-green-600">
                        {yellowCard.minute}'
                      </p>
                      <div className="flex items-center">
                        <img
                          className="w-10 mr-2 self-center rounded-md"
                          src={yellowCard.player.photo}
                          alt="Player 1"
                          onClick={() =>
                            openPhotoModalFunc(yellowCard.player.photo)
                          }
                        />
                        <div className="flex flex-col">
                          <p className="font-semibold">
                            {yellowCard.player.name}
                          </p>
                          <p className="text-yellow-500">Yellow Card</p>
                        </div>
                      </div>
                    </div>
                    {/* <div className=" px-2 py-2 flex flex-col  mb-1">
                                    <p className="justify-center text-center  mb-2 text-green-600"></p>
                                    <div className="flex items-center">
                                      <div className="flex flex-col">
                                        <p className="font-semibold"></p>
                                        <p className="text-gray-600"></p>
                                      </div>
                                      <div className="h-10 mr-2 self-center" />
                                    </div>
                                  </div> */}
                  </>
                ))}
                {ArrangedMatchStats?.team1?.redCards?.map((redCard) => (
                  <>
                    <div className=" px-2 py-2 flex flex-col  mb-1">
                      <p className="justify-center text-center  mb-2 text-green-600">
                        {redCard.minute}'
                      </p>
                      <div className="flex items-center">
                        <img
                          className="w-10 mr-2 self-center rounded-md"
                          src={redCard.player.photo}
                          alt="Player 1"
                          onClick={() =>
                            openPhotoModalFunc(redCard.player.photo)
                          }
                        />
                        <div className="flex flex-col">
                          <p className="font-semibold">{redCard.player.name}</p>
                          <p className="text-red-500">Red Card</p>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>

            <div className=" w-1/2 flex  justify-end px-1">
              <div className="flex flex-col">
                {ArrangedMatchStats?.team2?.yellowCards?.map((yellowCard) => (
                  <>
                    <div className=" px-2 py-2 flex flex-col  mb-1">
                      <p className="justify-center text-center  mb-2 text-green-600">
                        {yellowCard.minute}'
                      </p>
                      <div className="flex items-center justify-end">
                        <div className="flex flex-col items-end">
                          <p className="font-semibold">
                            {yellowCard.player.name}
                          </p>
                          <p className="text-yellow-500">Yellow Card</p>
                        </div>
                        <img
                          className="w-10 ml-2 self-center rounded-md"
                          src={yellowCard.player.photo}
                          alt="Player 1"
                          onClick={() =>
                            openPhotoModalFunc(yellowCard.player.photo)
                          }
                        />
                      </div>
                    </div>
                  </>
                ))}
                {ArrangedMatchStats?.team2?.redCards?.map((redCard) => (
                  <>
                    <div className=" px-2 py-2 flex flex-col  mb-1">
                      <p className="justify-center text-center  mb-2 text-green-600">
                        {redCard.minute}'
                      </p>
                      <div className="flex items-end justify-end">
                        <div className="flex flex-col items-end">
                          <p className="font-semibold">{redCard.player.name}</p>
                          <p className="text-red-500">Red Card</p>
                        </div>
                        <img
                          className="w-10 ml-2 self-center rounded-md"
                          src={redCard.player.photo}
                          alt="Player 1"
                          onClick={() =>
                            openPhotoModalFunc(redCard.player.photo)
                          }
                        />
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>

          <div className="flex justify-center">
            <p className="text-center font-medium text-lg  text-gray-500 m-1 uppercase">
              Game log
            </p>
          </div>
        </div>

        {/* Top Performers Section */}

        {/* Game Info Section */}
        <div className="border-t bg-gray-200 text-center px-1 py-1 border-b border-gray-300">
          <p className="text-gray-600">League Match</p>
        </div>

        {/* Venue Info Section */}
        <div className="flex border-t bg-gray-200">
          {/* Stadium Section */}
          <div className="w-1/2 px-2 py-2 text-center">
            <p className="font-semibold text-gray-700">
              {eachMatchData?.location}
            </p>
          </div>
          {/* Line and O/U Section */}
          <div className="w-1/2 px-2 py-2 text-center">
            <p className="text-gray-600">
              <span className="font-semibold">Vagad League</span>
            </p>
          </div>
        </div>
      </div>
      {/* Match Time Line */}
      {/* <div className="max-w-xl mx-auto p-4 space-y-6 bg-teal-400 rounded-md mb-2">
        <h2 className="text-2xl font-bold mb-4">Match Timeline</h2>
        <div className="space-y-2">
          {timeline?.map((event) => renderCard(event))}
        </div>
      </div> */}
    </>
  );
}

export default MatchScoreCard;
